import * as React from 'react'

import { spacing } from '@thg-commerce/enterprise-theme'

import {
  BulletPoint,
  Paragraph,
  StyledCheckmark,
  SubscriptionInfoBoxWrapper,
  TitleContainer,
} from './style'

export interface SubscriptionInfoBoxProps {
  title: {
    text: string
    icon?: React.ReactElement
  }
  subtitle?: React.ReactElement
  infoText?: {
    upsellText?: string
    infoTextList: string[]
  }
  subsText?: string
  additionalStyle?: {
    marginTop: number
    padding: number
  }
}

export const SubscriptionInfoBox = (props: SubscriptionInfoBoxProps) => {
  return (
    <SubscriptionInfoBoxWrapper additionalStyle={props.additionalStyle}>
      <TitleContainer>
        {props.title.text}
        {props.title.icon}
      </TitleContainer>
      {props.subtitle}
      {props.infoText && (
        <ul style={{ marginTop: `${spacing(1)}` }}>
          {props.infoText.upsellText && (
            <BulletPoint>
              <StyledCheckmark viewBox={'0 0 24 24'} focusable="false" />
              <div style={{ paddingLeft: `${spacing(2)}` }}>
                {props.infoText.upsellText}
              </div>
            </BulletPoint>
          )}
          {props.infoText.infoTextList?.length > 0 &&
            props.infoText.infoTextList.map((item, index) => (
              <BulletPoint key={index}>
                <StyledCheckmark viewBox={'0 0 24 24'} />
                <div style={{ paddingLeft: `${spacing(2)}` }}>{item}</div>
              </BulletPoint>
            ))}
        </ul>
      )}
      {props.subsText && <Paragraph>{props.subsText}</Paragraph>}
    </SubscriptionInfoBoxWrapper>
  )
}
